import { Lightning } from '@lightningjs/sdk'

import { Registry } from '@lightningjs/sdk'
import { getColor, grey50, grey960, primary600 } from '../../constants/colors'
import { UniNeueBold, UniNeueRegular } from '../../constants/fonts'
import { Images } from '../../constants/paths'
import { PLAYBACK_SIGNALS } from '../../constants/signals'
import { getAsset } from '../../utils/image'
import { debounce } from '../../utils/misc'
import ProgressBar from './progressbar'
import { ThumbnailOverlay } from './thumbnailOverlay'
import { formatTime, isValidNumber } from './utils'

const SEEK_JUMP_ANIM_TIMEOUT = 200
export const PROGRESS_MARGIN = 30

export default class Ranges extends Lightning.Component {
  private _currentTime = 0
  private _duration = Number.MIN_VALUE
  private _fadeTimeoutRW = 0
  private _fadeTimeoutFF = 0
  private _timeLimitVisible = true
  private _preventCurrentTimeUpdate = false
  private _mouseMoveCallback: Function

  static _template() {
    return {
      ScrubInfoContainer: {
        x: 0,
        y: -240,
        w: 345,
        h: 250,
        mountX: 0.5,
        visible: false,
        flex: {
          direction: 'col',
          alignItems: 'flex-end',
          justifyContent: 'center',
        },
        collision: true,

        ScrubTrickplay: {
          type: ThumbnailOverlay,
          w: 320,
          h: 180,
          visible: false,
        },
        ScrubInfo: {
          w: 345,
          h: 250,
          flex: {
            direction: 'row',
            alignItems: 'flex-end',
            justifyContent: 'center',
          },
          SeekRW: {
            flexItem: {
              marginBottom: 10,
            },
            x: 0,
            y: 0,
            w: 76,
            h: 32,
            SeekJumpRW: {
              x: (w) => w - 32,
              y: (h) => (h - 32) / 2 - 2,
              w: 32,
              h: 32,
              alpha: 0,
              rect: true,
              texture: Lightning.Tools.getSvgTexture(getAsset(Images.PLAYER_SEEK_JUMP), 32, 32),
            },
            SpeedIndicatorRW: {
              x: 0,
              y: 0,
              alpha: 1,
              w: 76,
              flex: {
                direction: 'row',
              },
              children: [
                {
                  rect: true,
                  w: 22,
                  h: 32,
                  alpha: 0,
                  flexItem: {
                    marginLeft: 1,
                    marginRight: 1,
                  },
                  texture: Lightning.Tools.getSvgTexture(
                    getAsset(Images.PLAYER_SPEED_INDICATOR),
                    44,
                    64,
                  ),
                },
                {
                  rect: true,
                  w: 22,
                  h: 32,
                  alpha: 0,
                  flexItem: {
                    marginLeft: 1,
                    marginRight: 1,
                  },
                  texture: Lightning.Tools.getSvgTexture(
                    getAsset(Images.PLAYER_SPEED_INDICATOR),
                    44,
                    64,
                  ),
                },
                {
                  rect: true,
                  w: 22,
                  h: 32,
                  alpha: 0,
                  flexItem: {
                    marginLeft: 1,
                    marginRight: 1,
                  },
                  texture: Lightning.Tools.getSvgTexture(
                    getAsset(Images.PLAYER_SPEED_INDICATOR),
                    44,
                    64,
                  ),
                },
              ],
            },
          },
          ScrubTime: {
            flexItem: {
              marginTop: 26,
            },
            w: 150,
            visible: false,
            text: {
              text: '',
              textAlign: 'center',
              fontSize: 32,
              fontFace: UniNeueBold,
            },
          },
          SeekFF: {
            flexItem: {
              marginBottom: 10,
            },
            x: 0,
            w: 76,
            h: 32,
            SeekJumpFF: {
              y: (h) => (h - 32) / 2,
              w: 32,
              h: 32,
              alpha: 0,
              rect: true,
              scaleX: -1,
              texture: Lightning.Tools.getSvgTexture(getAsset(Images.PLAYER_SEEK_JUMP), 32, 32),
            },
            SpeedIndicatorFF: {
              x: 0,
              alpha: 1,
              w: 76,
              flex: {
                direction: 'row',
              },
              children: [
                {
                  rect: true,
                  w: 22,
                  h: 32,
                  alpha: 0,
                  scale: -1,
                  flexItem: {
                    marginLeft: 1,
                    marginRight: 1,
                  },
                  texture: Lightning.Tools.getSvgTexture(
                    getAsset(Images.PLAYER_SPEED_INDICATOR),
                    44,
                    64,
                  ),
                },
                {
                  rect: true,
                  w: 22,
                  h: 32,
                  alpha: 0,
                  scale: -1,
                  flexItem: {
                    marginLeft: 1,
                    marginRight: 1,
                  },
                  texture: Lightning.Tools.getSvgTexture(
                    getAsset(Images.PLAYER_SPEED_INDICATOR),
                    44,
                    64,
                  ),
                },
                {
                  rect: true,
                  w: 22,
                  h: 32,
                  alpha: 0,
                  scale: -1,
                  flexItem: {
                    marginLeft: 1,
                    marginRight: 1,
                  },
                  texture: Lightning.Tools.getSvgTexture(
                    getAsset(Images.PLAYER_SPEED_INDICATOR),
                    44,
                    64,
                  ),
                },
              ],
            },
          },
        },
      },
      RangesContainer: {
        w: (w) => w,
        flex: {
          direction: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        },
        ProgressBar: {
          type: ProgressBar,
          w: (w) => w,
          h: 60,
          flexItem: {
            marginLeft: PROGRESS_MARGIN,
            marginRight: PROGRESS_MARGIN,
          },
          signals: {
            change: 'onProgressChanged',
          },
        },
        Times: {
          w: 1728,
          flex: {
            direction: 'row',
            justifyContent: 'space-between',
          },
          TimeProgress: {
            text: {
              text: '00:00',
              fontFace: UniNeueRegular,
              fontSize: 32,
            },
          },
          RightContainer: {
            flex: {
              direction: 'row',
            },
            TimeLimit: {
              text: {
                text: '00:00',
                fontFace: UniNeueRegular,
                fontSize: 32,
              },
            },
            LiveContainer: {
              w: 70,
              h: 36,
              rect: true,
              color: getColor(grey50),
              shader: {
                type: Lightning.shaders.RoundedRectangle,
                fillColor: getColor(grey50),
                radius: 4,
              },
              flexItem: {
                marginLeft: 24,
              },
              flex: {
                alignItems: 'center',
                justifyContent: 'center',
              },
              LiveText: {
                flexItem: {
                  marginTop: 4,
                },
                shader: null,
                text: {
                  text: 'LIVE',
                  textColor: getColor(grey960),
                  fontSize: 24,
                  fontFace: UniNeueBold,
                  textTransform: 'uppercase',
                },
              },
            },
          },
        },
      },
    }
  }

  set isLiveStream(v) {
    this.progressBar.isLiveStream = v
    this.liveContainer.visible = v
    this.timeProgress.alpha = v ? 0 : 1
  }

  get isLiveStream() {
    return this.progressBar.isLiveStream
  }

  get liveContainer() {
    return this.tag('LiveContainer')
  }

  get liveText() {
    return this.tag('LiveText')
  }

  get progressBar() {
    return this.tag('ProgressBar') as ProgressBar
  }

  get times() {
    return this.tag('Times')
  }

  get timeProgress() {
    return this.tag('TimeProgress')
  }

  set timeProgressText(value) {
    this.timeProgress.patch({ text: formatTime(value) })
  }

  get timeLimit() {
    return this.tag('TimeLimit')
  }

  set timeLimitText(value) {
    this.timeLimit.patch({
      text: `-${formatTime(value)}`,
    })
  }

  set timeLimitVisible(value: boolean) {
    this._timeLimitVisible = value
    this.timeLimit.visible = value
  }

  set currentTime(value) {
    if (!isValidNumber(value) || this._currentTime === value || this._preventCurrentTimeUpdate) {
      return
    }

    this.timeProgressText = this.progressBar.progress = this._currentTime = value
  }

  set timeScrubText(value) {
    this.scrubTime.patch({ text: formatTime(value) })
  }

  get scrubInfo() {
    return this.tag('ScrubInfo')
  }

  get scrubInfoContainer() {
    return this.tag('ScrubInfoContainer')
  }

  get scrubTime() {
    return this.tag('ScrubTime')
  }

  get scrubTrickplay() {
    return this.tag('ScrubTrickplay') as ThumbnailOverlay
  }

  get indicatorRW() {
    return this.tag('SpeedIndicatorRW')
  }

  get indicatorsRW() {
    return [...this.indicatorRW.children].reverse()
  }

  get indicatorFF() {
    return this.tag('SpeedIndicatorFF')
  }

  get indicatorsFF() {
    return this.indicatorFF.children
  }

  get seekJumpRW() {
    return this.tag('SeekJumpRW')
  }

  get seekJumpFF() {
    return this.tag('SeekJumpFF')
  }

  get currentTime() {
    return this._currentTime ?? 0
  }

  set duration(value) {
    if (!isValidNumber(value) || this._duration === value) {
      return
    }

    this.timeLimitText = this.progressBar.limit = this._duration = value
  }

  get duration() {
    return this._duration ?? 0
  }

  set atLiveEdge(v: boolean) {
    this.liveContainer.patch({
      shader: {
        fillColor: getColor(v ? primary600 : grey50),
      },
    })

    this.liveText.patch({
      text: {
        textColor: getColor(v ? grey50 : grey960),
      },
    })

    this.timeLimit.visible = !v && this._timeLimitVisible
  }

  set preventCurrentTimeUpdate(v: boolean) {
    this._preventCurrentTimeUpdate = v
  }

  _firstEnable() {
    const { currentTime, duration, progressBar } = this

    this.timeProgressText = currentTime
    this.timeLimitText = duration

    if (progressBar.progress !== currentTime && !this._preventCurrentTimeUpdate) {
      progressBar.progress = currentTime
    }

    if (progressBar.limit !== duration) {
      progressBar.limit = duration
    }
  }

  _enable() {
    this.seekJumpRW.alpha = 0
    this.seekJumpFF.alpha = 0

    this._mouseMoveCallback = debounce(this.scrubFromHover.bind(this), 25)
    Registry.addEventListener(window, 'mousemove', this._mouseMoveCallback)
  }

  _getFocused() {
    return this.progressBar
  }

  _disable() {
    Registry.clearTimeout(this._fadeTimeoutRW)
    Registry.clearTimeout(this._fadeTimeoutFF)
    Registry.removeEventListener(window, 'mousemove', this._mouseMoveCallback)
  }

  onProgressChanged(value) {
    this.signal(PLAYBACK_SIGNALS.restartControlsTimer)
    this.signal(PLAYBACK_SIGNALS.seek, value)
  }

  showSeekJumpRW() {
    this.seekJumpRW.setSmooth('alpha', 1, { duration: 0.1 })

    // Clear any existing fade timeout to prevent immediate fade-out
    if (this._fadeTimeoutRW) {
      Registry.clearTimeout(this._fadeTimeoutRW)
    }

    this._fadeTimeoutRW = Registry.setTimeout(() => {
      this.seekJumpRW.setSmooth('alpha', 0, { duration: 0.3 })
      this._fadeTimeoutRW = null
    }, SEEK_JUMP_ANIM_TIMEOUT)
  }

  showSeekJumpFF() {
    this.seekJumpFF.setSmooth('alpha', 1, { duration: 0.1 })

    // Clear any existing fade timeout to prevent immediate fade-out
    if (this._fadeTimeoutFF) {
      Registry.clearTimeout(this._fadeTimeoutFF)
    }

    this._fadeTimeoutFF = Registry.setTimeout(() => {
      this.seekJumpFF.setSmooth('alpha', 0, { duration: 0.3 })
      this._fadeTimeoutFF = null
    }, SEEK_JUMP_ANIM_TIMEOUT)
  }

  resetSeekJumpAnims() {
    Registry.clearTimeout(this._fadeTimeoutRW)
    Registry.clearTimeout(this._fadeTimeoutFF)

    this.seekJumpFF.fastForward('alpha')
    this.seekJumpRW.fastForward('alpha')

    this.seekJumpFF.alpha = 0
    this.seekJumpRW.alpha = 0
  }

  _handleHover() {
    this.fireAncestors('$updateFocusByHover', this)
    this.progressBar._focus()
  }

  _handleUnhover() {
    this.progressBar._unfocus()
  }

  _handleClick(element, localCoordinates) {
    if (element === this.progressBar) {
      const hasTrickplay = this.scrubTrickplay?.trickplayInfo !== null
      const { x } = localCoordinates
      const scrubTo = (x * this._duration) / this.progressBar.finalW
      this.signal('scrubFromClick', scrubTo, !hasTrickplay)
    } else if (element === this.scrubTrickplay || element === this.scrubTrickplay.playPauseButton) {
      this.signal('resumeFromTrickplay')
    }
  }

  scrubFromHover(event) {
    const { clientX, clientY } = event

    if (clientX >= this.finalX && clientX <= this.finalW + this.finalX) {
      const x = clientX - this.finalX
      const scrubTo = (x * this._duration) / this.finalW
      this.signal('scrubFromHover', scrubTo, clientY)
    }
  }
}
